module.exports = "/fonts/logo-pajakku-light-7ca1f06955d81aa90c342a75c60dfea9.svg";